import * as React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { BsArrowRight } from "react-icons/bs";

function ReuseableCard(props) {
  return (
    <>
      <div>
        <div className="">
          <Typography variant="h5">
            <span className="text-danger fs-2">{props.IconName}</span>
          </Typography>
          <Typography variant="body2" className="mt-3 fw-bolder">
            {props.text}
          </Typography>
          <Typography className="fs-5 mt-2">
            <button className="bg-body border-0 text-primary px-0 ">
              <BsArrowRight />
            </button>
          </Typography>
        </div>
      </div>
    </>
  );
}

export default ReuseableCard;
